import './src/styles/global.css';
import "./src/styles/responsive.css";